define([
    "dojo/_base/declare",
    "csi",
    "csi/heading/StringSelection",
    "csi/xml"
], function(declare,csi,StringSelection,xml) {

    return declare(StringSelection, {

        _toHtml: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData, /*Boolean*/bSub) {
            // summary: do not display (Unnamed) for empty rows
            if (xml.isClientUrl(ctx.getNodeURL())) {
                refNode.innerHTML = csi.EMPTY_CHAR;
            } else {
                this.inherited(arguments);
            }
        },

        /**
         * @override
         * removes the tooltip
         */
        _getRenderAction(ctx, h) {
            const ad = this.inherited(arguments);
			// in case of printing/pdf generation ad will be null
			if (ad) {
            	ad.bTooltip = false;
			}
            return ad;
        },

        getStore: function(/*Context*/ctx, /*Heading*/h, /*Any*/value, /*Boolean*/bAll) {
            // summary: get store for heading, set null in value
            return this.inherited(arguments, [ctx, h, null, bAll]);
        },

        getStoreOptions: function(/*Context*/ctx, /*Heading*/h) {
            // summary: set idProperty on the store to Url instead of Name
            return {idProperty:"$"};
        }

    });
});